const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

const part = (date: Date, options: Intl.DateTimeFormatOptions): string =>
  new Intl.DateTimeFormat('en-AU', { ...options, timeZone: TZ }).format(date);

const dateParts = (date: Date) => ({
  d: part(date, { day: '2-digit' }),
  m: part(date, { month: '2-digit' }),
  y: part(date, { year: 'numeric' }),
});

const timePart24 = (date: Date): string =>
  part(date, { hour: '2-digit', minute: '2-digit', hour12: false });

// mm/dd/yyyy
export const formatDateOnly = (dateStr: string): string => {
  const date = new Date(dateStr);
  const { d, m, y } = dateParts(date);
  return `${m}/${d}/${y}`;
};

// dd/mm
export const formatDayMonth = (dateStr: string): string => {
  const date = new Date(dateStr);
  const { d, m } = dateParts(date);
  return `${d}/${m}`;
};

// dd MMM (e.g. 04 Nov)
const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const formatDayMonthShort = (dateStr: string): string => {
  const date = new Date(dateStr);
  return `${String(date.getDate()).padStart(2, '0')} ${MONTHS[date.getMonth()]}`;
};

// dd MMM yyyy, optional 12h time
export const formatListDate = (dateStr: string, hasTime?: boolean): string => {
  const date = new Date(dateStr);
  const datePart = part(date, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  if (!hasTime) return datePart;
  const time = part(date, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).replace(/\s+(am|pm)$/i, '$1');
  return `${datePart} ${time}`;
};

// yyyy/mm/dd or dd/mm/yyyy, optional 24h time
export const formatDetailDate = (
  dateStr: string | null | undefined,
  hasTime?: boolean,
  order: 'YMD' | 'DMY' = 'YMD',
): string => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const { d, m, y } = dateParts(date);
  const base = order === 'DMY' ? `${d}/${m}/${y}` : `${y}/${m}/${d}`;
  return hasTime ? `${base} ${timePart24(date)}` : base;
};
